import { Box } from "@mui/material";
import { useTableLayoutClasses } from "../TableLayout.style";
import BasketIcon from "../../../AppIcons/AppIconsBasket";

type TBasketIconComponent = {
    item: any;
    additionalProps: any;
};

const BasketIconComponent = (props: TBasketIconComponent) => {
    const classes = useTableLayoutClasses();

    return (
        <Box sx={[classes.columnBasket]}>
            {props.item.showBasket && <BasketIcon />}
        </Box>
    );
};

export default BasketIconComponent;
